import { combineReducers } from 'redux';

import { reducer as hasTrait } from './hasTraitModule';

export default combineReducers({
	hasTrait,
});
